/** 与后端 gemini/upscale SUPPORTED_MIME_TYPES 一致：JPG / JPEG / PNG / WebP；不含 AVIF */

const SUPPORTED_FILE_MIMES = new Set([
  'image/jpeg',
  'image/jpg',
  'image/pjpeg',
  'image/png',
  'image/webp',
]);

const SUPPORTED_DATA_URL_RE = /^data:image\/(jpe?g|pjpeg|png|webp);base64,/i;

export const UNSUPPORTED_UPLOAD_IMAGE_FORMAT_MESSAGE_ZH =
  '图片格式不支持，请上传 JPG、PNG 或 WebP 格式图片。';

export const UNSUPPORTED_UPLOAD_IMAGE_FORMAT_MESSAGE_EN =
  'Unsupported image format. Please upload JPG, PNG, or WebP.';

export function getUnsupportedUploadImageFormatMessage(lang: 'zh' | 'en' = 'zh'): string {
  return lang === 'en' ? UNSUPPORTED_UPLOAD_IMAGE_FORMAT_MESSAGE_EN : UNSUPPORTED_UPLOAD_IMAGE_FORMAT_MESSAGE_ZH;
}

export function isSupportedUploadImageFile(file: File): boolean {
  const mime = (file.type || '').toLowerCase().split(';')[0].trim();
  if (mime) {
    if (mime === 'image/avif' || mime.includes('heic') || mime.includes('heif')) return false;
    if (SUPPORTED_FILE_MIMES.has(mime)) return true;
    if (mime.startsWith('image/')) return false;
  }
  const name = (file.name || '').toLowerCase();
  if (/\.(jpe?g|png|webp)$/.test(name)) return true;
  if (/\.(avif|heic|heif|gif|bmp|tif|tiff)$/.test(name)) return false;
  return false;
}

export function isSupportedUploadImageDataUrl(dataUrl: string): boolean {
  const trimmed = (dataUrl || '').trim();
  if (!trimmed) return false;
  if (SUPPORTED_DATA_URL_RE.test(trimmed)) return true;
  if (/^https?:\/\//i.test(trimmed)) return true;
  if (/^data:image\//i.test(trimmed)) return false;
  return true;
}
